module.exports = __webpack_public_path__ + "static/jonathan-agoot-98d0204552a7342680510c86ffa492bd.jpg";